'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  font-family: \'WebFaktSoftPro\', sans-serif;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  cursor: ', ';\n  text-align: ', ';\n  text-decoration: ', ';\n  font-weight: ', ';\n  font-size: ', 'px;\n  color: ', ';\n\n  &:hover {\n    color: ', ';\n    text-decoration: ', ';\n  }\n\n  ', ';\n\n  strong {\n    font-weight: ', ';\n  }\n'], ['\n  font-family: \'WebFaktSoftPro\', sans-serif;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  cursor: ', ';\n  text-align: ', ';\n  text-decoration: ', ';\n  font-weight: ', ';\n  font-size: ', 'px;\n  color: ', ';\n\n  &:hover {\n    color: ', ';\n    text-decoration: ', ';\n  }\n\n  ', ';\n\n  strong {\n    font-weight: ', ';\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      white-space: normal;\n      text-overflow: initial;\n      overflow: visible;\n      white-space: pre-wrap;\n      word-break: break-word;\n    '], ['\n      white-space: normal;\n      text-overflow: initial;\n      overflow: visible;\n      white-space: pre-wrap;\n      word-break: break-word;\n    ']);

exports.default = Text;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _layout = require('../layout');

var _theme = require('../theme');

var _theme2 = _interopRequireDefault(_theme);

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledText = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Inline)(_templateObject, function (props) {
  return props.interactive ? 'pointer' : props.notInteractive ? 'default' : 'inherit';
}, function (props) {
  return props.align;
}, function (props) {
  return props.noUnderline ? 'none' : 'inherit';
}, function (props) {
  return _constants.WEIGHT_MAP[props.weight];
}, function (props) {
  return _constants.SIZE_MAP[props.size];
}, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.colors[props.hoverColor];
}, function (props) {
  return props.onClick ? props.noUnderline ? 'none' : 'underline' : 'inherit';
}, function (props) {
  return props.multiline && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2);
}, function (props) {
  return props.theme.typography.fontWeightMedium;
});

function Text(props) {
  var _props$weight = props.weight,
      weight = _props$weight === undefined ? 'normal' : _props$weight,
      _props$size = props.size,
      size = _props$size === undefined ? 'small' : _props$size,
      _props$align = props.align,
      align = _props$align === undefined ? 'unset' : _props$align,
      _props$color = props.color,
      color = _props$color === undefined ? 'navy600' : _props$color,
      _props$hoverColor = props.hoverColor,
      hoverColor = _props$hoverColor === undefined ? 'none' : _props$hoverColor,
      interactive = props.interactive,
      noUnderline = props.noUnderline,
      onClick = props.onClick,
      children = props.children,
      _props$theme = props.theme,
      theme = _props$theme === undefined ? _theme2.default : _props$theme,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['weight', 'size', 'align', 'color', 'hoverColor', 'interactive', 'noUnderline', 'onClick', 'children', 'theme']);


  return React.createElement(
    StyledText,
    (0, _extends3.default)({
      onClick: onClick,
      weight: weight,
      color: color,
      hoverColor: hoverColor,
      align: align,
      interactive: interactive || onClick,
      noUnderline: noUnderline,
      size: size,
      theme: theme
    }, otherProps),
    children
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/text/text.js
// module id = 355
// module chunks = 114276838955818